<template>
  <v-container fluid class="px-0 py-0">
    <v-main>
      <v-row class="px-0 pt-12">
        <v-col>
          <h1 class="center--text gm-darkblue--text">Portfolio</h1>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" class="px-0 py-0">
          <div class="d-flex highlight-img"></div>
        </v-col>

        <v-col cols="12" class="overview-content px-0 py-0">
          <v-row class="d-none d-sm-flex px-12">
            <v-col cols="7">
              <v-card elevation="6">
                <v-card-title class="center--text gm-darkblue gm-whitish--text">
                  <h3>Projects</h3>
                </v-card-title>
                <v-card-text>
                  <p>
                    Our projects cut across design, constuction, installation, fabrication and maintenance operations within our core business areas.
                  </p>

                  <p>
                    Since its incorporation, GML is a fast rising indigenous company that
                    has become one of the leading contractors in Southern and Eastern part of
                    Nigeria primarily due to the quality of our completed works.
                  </p>

                  <v-row justify="center" class="pt-1">
                    <v-btn to="/projects" color="gmYellow" class="overview-btn">
                      <span class="gm-whitish--text dosis btn-text ml-3">See More</span>
                    </v-btn>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="5">
              <v-row>
                <v-col cols="12">
                  <v-card elevation="6">
                    <v-card-title class="center--text  gm-blue gm-whitish--text">
                      <h3>Gallery</h3>
                    </v-card-title>
                    <v-card-text>
                      <v-carousel
                      id="small-carousel"
                      height="80vh"
                      cycle
                      :show-arrows="false"
                      hide-delimiter-background
                      delimiter-icon="mdi-minus"
                      >
                        <v-carousel-item>
                          <v-img :src="require('../assets/images/projects/project-1.jpg')" />
                        </v-carousel-item>
                        <v-carousel-item>
                          <v-img :src="require('../assets/images/projects/project-2.jpg')" />
                        </v-carousel-item>
                        <v-carousel-item>
                          <v-img :src="require('../assets/images/projects/project-3.jpg')" />
                        </v-carousel-item>
                        <v-carousel-item>
                          <v-img :src="require('../assets/images/projects/project-4.jpg')" />
                        </v-carousel-item>
                        <v-carousel-item>
                          <v-img :src="require('../assets/images/projects/project-5.jpg')" />
                        </v-carousel-item>
                      </v-carousel>

                      <v-row justify="center" class="pt-1">
                        <v-btn to="/projects" color="gmYellow" class="overview-btn">
                          <span class="gm-whitish--text dosis btn-text ml-3">See More</span>
                        </v-btn>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row class="d-sm-none d-flex px-4">
            <v-col cols="12">
              <v-card elevation="6">
                <v-card-title class="center--text gm-darkblue gm-whitish--text">
                  <h3>Portfolio</h3>
                </v-card-title>
                <v-card-text>
                  <p>
                    Green masters Ltd is a Nigerian company that specialises in design,
                    building, and development of infrastructure, marine works, bridges,
                    buildings, roads, highways, EPC contracts, and other civil works.
                  </p>

                  <p>
                    Since its incorporation, GML is a fast rising indigenous company that
                    has become one of the leading contractors in Southern and Eastern part of
                    Nigeria primarily due to the quality of our completed works.
                  </p>

                  <v-row justify="center" class="pt-1">
                    <v-btn to="/about" color="gmYellow" class="overview-btn">
                      <span class="gm-whitish--text dosis btn-text ml-3">See More</span>
                    </v-btn>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12">
              <v-card elevation="6">
                <v-card-title class="center--text  gm-blue gm-whitish--text">
                  <h3>Gallery</h3>
                </v-card-title>
                <v-card-text>
                  <v-carousel
                  id="small-carousel"
                  height="100vh"
                  cycle
                  :show-arrows="false"
                  hide-delimiter-background
                  delimiter-icon="mdi-minus"
                  >
                    <v-carousel-item>
                      <v-img :src="require('../assets/images/projects/project-1.jpg')" />
                    </v-carousel-item>
                    <v-carousel-item>
                      <v-img :src="require('../assets/images/projects/project-2.jpg')" />
                    </v-carousel-item>
                    <v-carousel-item>
                      <v-img :src="require('../assets/images/projects/project-3.jpg')" />
                    </v-carousel-item>
                    <v-carousel-item>
                      <v-img :src="require('../assets/images/projects/project-4.jpg')" />
                    </v-carousel-item>
                    <v-carousel-item>
                      <v-img :src="require('../assets/images/projects/project-5.jpg')" />
                    </v-carousel-item>
                  </v-carousel>

                  <v-row justify="center" class="pt-1">
                    <v-btn to="/projects" color="gmYellow" class="overview-btn">
                      <span class="gm-whitish--text dosis btn-text ml-3">See More</span>
                    </v-btn>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-main>
  </v-container>
</template>

<script>
export default {
  name: 'projects-highlight'
}
</script>

<style scoped>
.highlight-img {
  width: 100vw;
  height: 30vh;
  background-image: url('../assets/images/projects/refinery-maintenance.jpg');
  background-attachment: fixed;
  background-position: 50% 0%;
  background-repeat: no-repeat;
  background-size: cover;
}

.overview-content {
  transform: translateY(-32px);
}
</style>
